/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import {
  Box, Grid,
} from '@mui/material';
import InputContainer from '../../InputContainer';
import InputGroup from './components/InputGroup';
import { FieldArray, FormikProvider } from 'formik';
import CustomizedSwitch from './components/CustomizedSwitch';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

function Contacts({ formik, swithRegisterBankAccount, onSwithRegisterBankAccount }) {
  const {
    values,
  } = formik;

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.between('xs', 'lg'));

  const hasContacts = values.contacts && values.contacts.length > 0;

  return (
    <InputContainer title="Contatos" buttonsForDynamicInputs>
      <FormikProvider value={formik}>
        <FieldArray name="contacts">
          {({ remove, push }) => (
            <Grid container rowGap={matches ? 4 : 2}>
              {hasContacts && (
                values.contacts.map((item, index) => (
                  <React.Fragment key={index}>
                    <InputGroup
                      index={index}
                      onRemove={() => remove(index)}
                      onAdd={() => push({
                        representative: '',
                        position: '',
                        phone_number: '',
                        contact_number: '',
                        email: '',
                      })}
                    />
                  </React.Fragment>
                ))
              )}
            </Grid>
          )}
        </FieldArray>
      </FormikProvider>
      <Box display="flex" justifyContent="center" mt={2}>
        <CustomizedSwitch
          title="Cadastrar dados bancários?"
          swithRegisterBankAccount={swithRegisterBankAccount}
          onSwithRegisterBankAccount={onSwithRegisterBankAccount}
        />
      </Box>
    </InputContainer>
  );
}

export default Contacts;
